import { BaseAPI } from 'API/BaseApi';
import { eAPITags } from 'API/eAPITags';
import {
  convertFromDiscountsResponseArrayToDiscountsDataArray,
  IDiscountsData,
} from '../../../ui-toolkit/discounts/types/IDiscounts';

export const DiscountApi = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    getDiscounts: build.query<IDiscountsData[], string>({
      query: (orderId) => `/orders/v5/admin/${orderId}/discounts`,
      providesTags: (res, err, orderId) => [{ type: eAPITags.OrderDiscounts, id: orderId }],
      transformResponse: convertFromDiscountsResponseArrayToDiscountsDataArray,
    }),
  }),
});

export const { useGetDiscountsQuery } = DiscountApi;
